export default "__VITE_ASSET__DUm6Nnr3__"